import { useUsageLimits } from "@/hooks/pricing/useUsageLimits";
import { formatPromptCount } from "@/utils/ai/utils";

interface UsageTextProps {
  hasClaudeCodeAuth?: boolean;
}

export const UsageText = ({ hasClaudeCodeAuth = false }: UsageTextProps) => {
  const { remainingUsage } = useUsageLimits();

  const getUsageText = () => {
    if (hasClaudeCodeAuth) {
      if (remainingUsage.monthlyPromptsLeft !== undefined) {
        return `${formatPromptCount(
          remainingUsage.monthlyPromptsLeft,
        )} Tempo credits`;
      }
      if (remainingUsage.tokensLeft !== undefined) {
        return `${remainingUsage.tokensLeftDisplay} Tempo tokens`;
      }
      return "Tempo usage";
    }

    // Default detailed format
    const usageLines: string[] = [];

    if (remainingUsage.dailyPromptsLeft !== undefined) {
      usageLines.push(
        `${formatPromptCount(
          remainingUsage.dailyPromptsLeft,
        )} daily credit(s) left`,
      );
    }
    if (remainingUsage.monthlyPromptsLeft !== undefined) {
      usageLines.push(
        `${
          remainingUsage.monthlyPromptsLeft === Infinity
            ? "Unlimited"
            : formatPromptCount(remainingUsage.monthlyPromptsLeft)
        } monthly credit(s) left`,
      );
    }
    if (remainingUsage.extraPromptsInPackages !== undefined) {
      usageLines.push(
        `${formatPromptCount(
          remainingUsage.extraPromptsInPackages,
        )} extra credit(s) left`,
      );
    }
    if (remainingUsage.tokensLeft !== undefined) {
      usageLines.push(
        `${
          remainingUsage.tokensLeft === Infinity
            ? "Unlimited"
            : remainingUsage.tokensLeftDisplay
        } tokens left`,
      );
    }

    return usageLines;
  };

  const usageContent = getUsageText();

  return (
    <>
      {hasClaudeCodeAuth ? (
        <span className="text-secondary-n-50">{usageContent}</span>
      ) : (
        <div className="flex items-center gap-1 text-secondary-n-50 m-auto mb-2 flex-col">
          {Array.isArray(usageContent) &&
            usageContent.map((line, index) => <div key={index}>{line}</div>)}
        </div>
      )}
    </>
  );
};
